export default class LoadProfileSnippets {
  constructor(context) {
    this.context = context;
  }

  run(agentProfile = {}) {
    const { emailGreetingSnippetId, emailSignatureSnippetId } = agentProfile;
    let snippetIds = [];

    if (emailGreetingSnippetId) {
      snippetIds.push(emailGreetingSnippetId);
    }

    if (emailSignatureSnippetId) {
      snippetIds.push(emailSignatureSnippetId);
    }

    if (snippetIds.length > 0) {
      this.context.gateways.snippet.fetch({ ids: snippetIds });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/load_profile_snippets.js